import { duration } from 'src/replicant/utils/duration';

// How many energy we give as gift
export const energyGiftAmount = 1;

// Maximal energy that user could have to be able claim reward
export const maxClaimEnergy = 99;

// Cleanup old send messages from state
export const cleanupSendInterval = duration({ days: 30 });
